<template>
  <div class="editable-page-model-h5-26" :style="{backgroundColor:editablePageConfig.editable_page_config_content.back_color,paddingTop:editablePageConfig.editable_page_config_content.margin_top,paddingBottom:editablePageConfig.editable_page_config_content.margin_bottom}">
    <div class="floor-ad" v-if="editablePageConfig.editable_page_config_content.image[0].list[0]">
      <img :src="editablePageConfig.editable_page_config_content.image[0].list[0].path">
    </div>
  </div>
</template>
<script>
export default {
  name: 'Model26',
  data () {
    return {
    }
  },
  props: ['editablePageConfig'],
  computed: {

  },
  methods: {

  }
}
</script>
<style scoped>
.editable-page-model-h5-26 .floor-ad img {
  width: 100%;
}
</style>
